// From: https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete
type AutoComplete =
  | 'additional-name'
  | 'address-level1'
  | 'address-level2'
  | 'address-level3'
  | 'address-level4'
  | 'address-line1'
  | 'address-line2'
  | 'address-line3'
  | 'bday'
  | 'bday-day'
  | 'bday-month'
  | 'bday-year'
  | 'cc-additional-name'
  | 'cc-csc'
  | 'cc-exp'
  | 'cc-exp-month'
  | 'cc-exp-year'
  | 'cc-family-name'
  | 'cc-family-name'
  | 'cc-given-name'
  | 'cc-name'
  | 'cc-number'
  | 'cc-type'
  | 'country'
  | 'country-name'
  | 'current-password'
  | 'email'
  | 'family-name'
  | 'given-name'
  | 'honorific-prefix'
  | 'honorific-suffix'
  | 'impp'
  | 'language'
  | 'name'
  | 'new-password'
  | 'nickname'
  | 'off'
  | 'on'
  | 'one-time-code'
  | 'organization'
  | 'organization-title'
  | 'photo'
  | 'postal-code'
  | 'sex'
  | 'street-address'
  | 'tel'
  | 'tel-area-code'
  | 'tel-country-code'
  | 'tel-extension'
  | 'tel-local'
  | 'tel-national'
  | 'transaction-amount'
  | 'transaction-currency'
  | 'url'
  | 'username';

type ButtonIcon = {
  'aria-label': string;
  class: string;
  icon: Icon;
  onClick: (event: MouseEvent) => void;
  onKeyDown: (event: KeyboardEvent) => void;
  title: string;
};

type Icon = {
  class?: string;
  icon: string;
};

// From: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-inputmode
type InputMode = 'decimal' | 'email' | 'none' | 'numeric' | 'search' | 'text' | 'tel' | 'url';

// From: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#input_types
type Type =
  | 'date'
  | 'datetime-local'
  | 'email'
  | 'month'
  | 'number'
  | 'password'
  | 'search'
  | 'tel'
  | 'text'
  | 'time'
  | 'url'
  | 'week';

export { AutoComplete, ButtonIcon, Icon, InputMode, Type };
